import { isDefined } from "utils";
import { EmptyString } from "constants/strings";

//TODO Написать wrapper для возможности принимать не 3 слова, а два.
export const plural = (number: number, titles: Array<string>) => {
  const cases = [2, 0, 1, 1, 1, 2];

  return titles[number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]];
};

export function printDefined(value: string | number): string | number {
  return isDefined(value) ? value : EmptyString;
}

export function printSimple(value: string): string {
  return isDefined(value) ? value : "";
}

export function getTextLength(
  text: string,
  fontSize = 16,
  iterFn?: (ch: string, i: number, textLength: number) => boolean
): number {
  let upperCount = 0;
  let lowerCount = 0;
  let restCount = 0;
  let textLength = 0;
  try {
    for (let i = 0; i < text.length; i++) {
      const ch = text[i];
      if ((ch >= "A" && ch <= "Z") || (ch >= "А" && ch <= "Я")) {
        upperCount++;
      } else if ((ch >= "a" && ch <= "z") || (ch >= "а" && ch <= "я") || (ch >= "0" && ch <= "9")) {
        lowerCount++;
      } else {
        restCount++;
      }
      textLength = Math.round((fontSize / 16) * (11 * upperCount + 9 * lowerCount + 6 * restCount));
      if (typeof iterFn === "function") {
        if (iterFn(ch, i, textLength)) {
          break;
        }
      }
    }
  } catch (err) {}
  return textLength;
}

export function getTextLimitIndex(text: string, limit: number, fontSize = 16): number {
  let index = 0;
  getTextLength(text, fontSize, (_: string, i: number, textLength: number) => {
    if (textLength >= limit) {
      index = i;
      return true;
    }
    return false;
  });
  return index;
}

export function cropText(text: string, length: number, end: string = ""): string | null {
  if (text) {
    let index = text.indexOf(" ", length);
    if (index === -1) {
      return text;
    }
    return text.slice(0, index) + end;
  }
  return null;
}

export function isEmptyString(value: string) {
  if (typeof value === "string") {
    const parts = value.split(" ").length;

    if (parts === 1) {
      return !value.length;
    }

    if (value.length - parts < 0) {
      return true;
    }
  }

  return false;
}

export function trimToLength(text: string, limit: number, end: string = "...") {
  if (typeof text !== "string" || typeof limit !== "number" || limit < 0 || Number.isNaN(limit)) {
    return "";
  }

  return text.length <= limit ? text : text.substring(0, limit) + end;
}

export function getEnumeration(arr: Array<string>): string {
  if (arr.length > 2) {
    const list = [...arr];
    const last = list.pop();
    return list.join(", ") + " или " + last;
  }
  return arr.join(" или ");
}

export const getCount = (count: number, max: number, entity: string[], short = true) => {
  if (!Number.isFinite(count) || count < 0) {
    count = 0;
  }

  if (!Number.isFinite(max) || max < 0) {
    max = 0;
  }
  const maxStr = !short && max > 0 ? ` из ${max} ` : " ";
  return `${count}${maxStr}${plural(count, entity)}`;
};

export const removeSpaces = (value: string): string => {
  if (typeof value !== "string") {
    return "";
  }
  return value.replace(/\s+/g, "");
};

export const getSearchWord = (search: string[], count: number): string => {
  if (!Array.isArray(search) || search.length < 3) {
    throw new Error("Минимальная длина массива: 3");
  }

  if (typeof count !== "number" || isNaN(count)) {
    throw new Error("Count должен быть числом");
  }

  if (count === 0) return search[2];
  if (count === 1) return search[0];

  return plural(count, search);
};

export const getEntityWord = (entity: string[], count: number): string => {
  if (!Array.isArray(entity) || entity.length < 2) {
    throw new Error("Минимальная длина массива: 3");
  }

  if (typeof count !== "number" || isNaN(count)) {
    throw new Error("Count должен быть числом");
  }

  const lastDigit = count % 10;
  const lastTwoDigits = count % 100;

  if (count === 0 || (lastTwoDigits >= 11 && lastTwoDigits <= 14)) {
    return entity[1];
  }

  if (lastDigit === 1) {
    return entity[0];
  }

  return entity[1];
};

const getFraction = (count: number, max: number) => {
  return `${count} из ${max}`;
};

export const getSearchText = (
  count: number,
  max: number,
  search: Array<string>,
  entity: Array<string>,
  short: boolean
) => {
  return short
    ? `Всего ${getSearchWord(search, count).toLowerCase()} ${count} ${plural(count, entity)}`
    : `${getSearchWord(search, count)} ${getFraction(count, max)} ${getEntityWord([entity[1], entity[2]], max)}`;
};

export const truncateText = (
  text: string,
  truncateStart: number,
  truncateEnd: number = 0,
  ellipsis: string = "..."
): string => {
  if (typeof text !== "string") {
    throw new Error("Текст должен быть строкой");
  }

  if (typeof truncateStart !== "number" || isNaN(truncateStart) || truncateStart < 0) {
    throw new Error("truncateStart должен быть неотрицательным числом");
  }

  if (typeof truncateEnd !== "number" || isNaN(truncateEnd) || truncateEnd < 0) {
    throw new Error("truncateEnd должен быть неотрицательным числом");
  }

  if (typeof ellipsis !== "string") {
    throw new Error("ellipsis должен быть строкой");
  }

  if (text.length <= truncateStart + truncateEnd) {
    return text;
  }

  const start = text.slice(0, truncateStart);
  const end = truncateEnd > 0 ? text.slice(-truncateEnd) : "";

  return `${start}${ellipsis}${end}`;
};

export const copyText = async (text: string): Promise<void> => {
  if (typeof text !== "string") {
    console.error("copyText: Текст должен быть строкой");
    return;
  }

  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
    } else {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
    }
  } catch (error) {
    console.error("Ошибка при копировании текста:", error);
  }
};

export const getFileNameWithoutExtension = (docName: string) => {
  const lastDotIndex = docName.lastIndexOf(".");

  if (lastDotIndex === -1 || lastDotIndex === 0) {
    return docName;
  }

  return docName.substring(0, lastDotIndex);
};

/**
 * Преобразует строку так, что первая буква становится заглавной, а остальные - строчными
 */
export const capitalize = (text: string): string => {
  if (!text || typeof text !== "string" || text.length === 0) {
    return "";
  }

  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};
